import './search-button.scss'
import type { InputHandles } from '@vista-digital/occ-ui'
import { AutoCompleteType, Icon, Input, InputMode, InputType, Modal, ModalMode } from '@vista-digital/occ-ui'
import { useEffect, useRef, useState } from 'react'
import { MIN_SEARCH_LENGTH } from '@/common/const/minSearchLength.const'
import { useDebounce } from '@/common/hooks/useDebounce'
import { useInitialData } from '@/common/hooks/useInitialData'
import { Category } from '@/features/layout/header/subcomponents/searchButton/category/Category'
import { useSiteSearchResults } from '@/features/layout/header/subcomponents/searchButton/useSiteSearchResults'
import { navigationMenuStore } from '@/features/layout/stores/navigationMenu.store'

export const SearchButton = () => {
    const { header } = useInitialData()
    const [isModalOpen, setIsModalOpen] = useState(false)

    const openModal = () => {
        setIsModalOpen(true)
        navigationMenuStore.hideNavMenu()
    }

    const closeModal = () => {
        setIsModalOpen(false)
        setValue('')
    }

    const [value, setValue] = useState('')
    const debouncedValue = useDebounce(value, 500)
    const [searchResult, hasResults, isLoading] = useSiteSearchResults(debouncedValue)
    const displayNoResult =
        value.length >= MIN_SEARCH_LENGTH && !hasResults && debouncedValue.length >= MIN_SEARCH_LENGTH && !isLoading

    // auto-focus
    const ref = useRef<InputHandles>(null)
    useEffect(() => ref.current?.focus(), [isModalOpen])

    return (
        <>
            <button className="action-buttons__search bg-off-white" onClick={openModal}>
                <Icon name="search" />
            </button>
            <Modal show={isModalOpen} onClose={closeModal} mode={ModalMode.FullScreen} className={'search-modal'}>
                <div className="modal-wrapper">
                    <Input
                        ref={ref}
                        value={value}
                        inputMode={InputMode.Text}
                        name="search"
                        type={InputType.Text}
                        placeholder={header.search.placeholderText}
                        onChange={e => setValue(e.target.value)}
                        autoCompleteType={AutoCompleteType.Off}
                    />

                    {searchResult.map(([title, items], i) => (
                        <Category key={i} title={title} items={items} onClick={closeModal} />
                    ))}

                    {displayNoResult && <div className="no-results">{header.search.noResultsFoundMessage}</div>}
                </div>
            </Modal>
        </>
    )
}
